export default "/kiban/_next/static/images/mail-2d0c0935c17db207499e9d6627bbdeff.png";